// Track the active listeners so we can remove them on re-init
let currentScrollHandler = null;
let currentTeardown = null;

function setupComplexStickyBehavior() {
  if (window.innerWidth < 990) return;

  const productInfo = document.querySelector('.product__info-container');
  const mediaWrapper = document.querySelector('.product__media-wrapper');

  if (!productInfo || !mediaWrapper) return;

  // Guard against double-init on the same container.
  // Set the flag immediately so concurrent calls are blocked.
  // (custom.css : tant que ce drapeau n'est pas pose, le bloc d'achat est cale en bas en CSS.)
  if (productInfo.dataset.stickyPending || productInfo.querySelector('.sticky-top-section')) {
    return;
  }
  productInfo.dataset.stickyPending = '1';

  // Remove the previous listeners so detached closures don't accumulate
  if (currentTeardown) {
    currentTeardown();
    currentTeardown = null;
  }

  // Create wrapper sections
  const topSection = document.createElement('div');
  topSection.className = 'sticky-top-section';

  const middleSection = document.createElement('div');
  middleSection.className = 'sticky-middle-section';

  const bottomSection = document.createElement('div');
  bottomSection.className = 'sticky-bottom-section';

  // Find and move elements
  const priceEl = productInfo.querySelector('[id^="price-"]');
  const taxEl = productInfo.querySelector('.product__tax');
  const installmentEl = productInfo.querySelector('div:has([id^="product-form-installment"])');
  const titleEl = productInfo.querySelector('.product__title');
  const descEl = productInfo.querySelector('.product__description');

  // Move to top section
  if (priceEl) topSection.appendChild(priceEl);
  if (taxEl) topSection.appendChild(taxEl);
  if (installmentEl) topSection.appendChild(installmentEl);
  if (titleEl) topSection.appendChild(titleEl);

  // Move description to middle
  if (descEl) middleSection.appendChild(descEl);

  // Move everything else to bottom
  const remainingEls = Array.from(productInfo.children);
  remainingEls.forEach(el => {
    if (!topSection.contains(el) && !middleSection.contains(el)) {
      bottomSection.appendChild(el);
    }
  });

  // Replace container contents
  productInfo.innerHTML = '';
  productInfo.appendChild(topSection);
  productInfo.appendChild(middleSection);
  productInfo.appendChild(bottomSection);

  // MoBe 21/10/2026 (recette du 20/10) : les mesures sont refaites a chaque fois que le contenu
  // change de taille (accordeon ouvert ou ferme, note de livraison, titre ajuste, police chargee)
  // et a chaque redimensionnement de la fenetre. Avant, elles etaient prises une seule fois,
  // 300 ms apres le chargement : un accordeon s'ouvrait sous le bas de l'ecran, et le bloc
  // d'achat sautait vers le bas apres l'affichage. Le calcul au defilement est inchange.
  const wrapper = productInfo.parentElement;
  const mediaList = mediaWrapper.querySelector('.product__media-list') || mediaWrapper;

  // Marge basse au repos = 1rem au-dessus du bas du viewport (robuste au font-size racine).
  const BOTTOM_GAP = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

  let viewportHeight = window.innerHeight;
  let stickTop = 0; // decalage sticky effectif (52px en CSS, negatif si la colonne depasse l'ecran)
  let contentHeight = 0; // hauteur reelle du contenu, padding a 0
  let columnDocTop = 0; // haut de la colonne au repos, dans le document
  let mediaListBottomDoc = 0; // bas de la liste media, dans le document

  // Padding-bottom de .sticky-middle-section calcule depuis scrollY seul (aucune lecture du
  // layout ici : pas d'emballement). screenTop = haut de la colonne a l'ecran (descend avec le
  // scroll puis se fige a stickTop). Le bas du contenu vise le MINIMUM entre 1rem au-dessus du
  // bas de l'ecran et le bas de la liste media a l'ecran : le bloc du bas reste colle en bas,
  // puis s'accroche au bas du media. Contenu plus grand que la cible => padding 0.
  function applyScroll(scrollY) {
    if (window.innerWidth < 990) return;
    const screenTop = Math.max(stickTop, columnDocTop - scrollY);
    const mediaBottomOnScreen = mediaListBottomDoc - scrollY;
    const desiredBottom = Math.min(viewportHeight - BOTTOM_GAP, mediaBottomOnScreen);
    const padding = Math.max(0, desiredBottom - contentHeight - screenTop);
    const px = padding + 'px';
    if (middleSection.style.paddingBottom !== px) {
      middleSection.style.paddingBottom = px;
    }
  }

  // Mesures faites padding a 0 (comme a l'origine). Appelee au demarrage, puis par le
  // ResizeObserver et l'evenement resize : jamais pendant le defilement.
  function measure() {
    middleSection.style.paddingBottom = '0px';
    productInfo.style.removeProperty('top');
    if (!productInfo.isConnected || window.innerWidth < 990) return;

    viewportHeight = window.innerHeight;
    // .product__info-container EST l'element sticky (classe product__column-sticky) : top 52px en CSS.
    const cssTop = parseFloat(getComputedStyle(productInfo).top) || 0;
    const rectTop = productInfo.getBoundingClientRect().top;
    contentHeight = bottomSection.getBoundingClientRect().bottom - rectTop;
    // Haut de la colonne au repos, lu sur son parent (qui ne colle pas) : juste meme page defilee.
    columnDocTop =
      wrapper.getBoundingClientRect().top +
      window.scrollY +
      (parseFloat(getComputedStyle(wrapper).paddingTop) || 0) +
      (parseFloat(getComputedStyle(productInfo).marginTop) || 0);
    mediaListBottomDoc = mediaList.getBoundingClientRect().bottom + window.scrollY;

    // Colonne plus haute que l'ecran (accordeon ouvert, fenetre basse) : elle colle par le bas,
    // pour que tout son contenu reste atteignable en faisant defiler la page.
    stickTop = Math.min(cssTop, viewportHeight - BOTTOM_GAP - contentHeight);
    if (stickTop < cssTop) {
      productInfo.style.setProperty('top', stickTop + 'px', 'important');
    }

    applyScroll(window.scrollY);
  }

  currentScrollHandler = () => applyScroll(window.scrollY);
  window.addEventListener('scroll', currentScrollHandler, { passive: true });
  window.addEventListener('resize', measure);

  // Tailles surveillees : haut (titre), description, bas (accordeons, note), liste media.
  // Pas .sticky-middle-section elle-meme : son padding change au defilement.
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
  if (resizeObserver) {
    [topSection, descEl, bottomSection, mediaList].forEach((el) => {
      if (el) resizeObserver.observe(el);
    });
  }

  currentTeardown = () => {
    window.removeEventListener('scroll', currentScrollHandler);
    window.removeEventListener('resize', measure);
    if (resizeObserver) resizeObserver.disconnect();
    currentScrollHandler = null;
  };

  // Mesure immediate (plus de delai de 300 ms) : le bloc d'achat reste a la place que le CSS
  // lui a donnee au premier affichage.
  measure();
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupComplexStickyBehavior);
} else {
  setupComplexStickyBehavior();
}

// Re-initialize when a product-info element connects to the DOM.
// This covers combined-listings / product-swap: handleSwapProduct in product-info.js
// replaces the entire <product-info> element, detaching the old middleSection.
// The new element fires 'product-info:loaded' from its connectedCallback.
document.addEventListener('product-info:loaded', setupComplexStickyBehavior);

// Reinitialize on Shopify section reload (theme editor)
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', setupComplexStickyBehavior);
}

/**
 * Product Accordion Animation
 * Same smooth height animation as footer accordions
 * Animates both opening AND closing
 */

(function() {
  'use strict';

  function initProductAccordions() {
    const accordions = document.querySelectorAll('.product__accordion details');

    accordions.forEach(details => {
      // Skip if already initialized
      if (details.dataset.accordionInit) return;
      details.dataset.accordionInit = 'true';

      const summary = details.querySelector('summary');
      const content = details.querySelector('.accordion__content');

      if (!summary || !content) return;

      // Set initial state - closed
      if (!details.open) {
        content.style.height = '0px';
        content.style.overflow = 'hidden';
      }

      // Prevent default and handle manually for smooth animations
      summary.addEventListener('click', function(e) {
        e.preventDefault();

        const isCurrentlyOpen = details.hasAttribute('open');

        if (isCurrentlyOpen) {
          // CLOSING animation
          const startHeight = content.scrollHeight + 'px';
          content.style.height = startHeight;

          // Force reflow
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              content.style.height = '0px';
            });
          });

          // Remove open attribute after animation completes
          setTimeout(() => {
            details.removeAttribute('open');
          }, 260);

        } else {
          // OPENING animation
          details.setAttribute('open', '');

          // Get the target height
          const targetHeight = content.scrollHeight + 'px';

          // Start from 0
          content.style.height = '0px';

          // Animate to target height
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              content.style.height = targetHeight;
            });
          });

          // Set to auto after animation for dynamic content
          setTimeout(() => {
            if (details.hasAttribute('open')) {
              content.style.height = 'auto';
            }
          }, 260);
        }
      });
    });
  }

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccordions);
  } else {
    initProductAccordions();
  }

  // Reinitialize on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', initProductAccordions);

})();
